import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Modal, ModalBody, ModalTitle, SelectBox, Spinner } from "@vertesia/ui/core";
import { useState } from "react";
import { useUITranslation } from '../../../i18n/index.js';
export var ExportTypes;
(function (ExportTypes) {
    ExportTypes["CSV"] = "CSV";
    ExportTypes["JSON"] = "JSON";
})(ExportTypes || (ExportTypes = {}));
;
export function ExportPropertiesModal({ isExporting, isOpen, onClose }) {
    const title = "Export Object Properties";
    return (_jsxs(Modal, { onClose: () => onClose(undefined), isOpen: isOpen, children: [_jsx(ModalTitle, { children: title }), _jsxs(ModalBody, { children: [!isExporting &&
                        _jsx(SelectPanel, { onClose: onClose }), isExporting &&
                        _jsx(WaitingPanel, {})] })] }));
}
function SelectPanel({ onClose }) {
    const { t } = useUITranslation();
    const [exportType, setExportType] = useState(undefined);
    const [exportAll, setExportAll] = useState(undefined);
    const selectionOption = ["Export selected objects", "Export all objects"];
    const exportAllBoolean = (option) => {
        return option == selectionOption[1];
    };
    const onSubmit = () => {
        onClose(exportType, exportAllBoolean(exportAll));
    };
    return (_jsxs(ModalBody, { className: "min-h-[104px] pt-0 flex flex-col gap-y-4", children: [_jsx("div", { className: 'h-1/3', children: _jsx(SelectBox, { options: selectionOption, value: exportAll, onChange: setExportAll, placeholder: t('store.chooseWhatToExport'), className: "h-full w-full text-sm", filterBy: "name", isClearable: true }) }), _jsxs("div", { className: 'h-1/2 flex flex-col gap-y-8 content-between', children: [_jsx(SelectBox, { options: Object.values(ExportTypes), value: exportType, onChange: setExportType, placeholder: t('store.chooseAFormat'), className: "h-full w-full text-sm", filterBy: "name", isClearable: true }), _jsx(Button, { className: "w-full", isDisabled: !exportType || !exportAll, onClick: onSubmit, children: t('store.actions.exportProperties') })] })] }));
}
function WaitingPanel({}) {
    const { t } = useUITranslation();
    return (_jsx(ModalBody, { className: "min-h-[84px] pt-0", children: _jsxs("div", { className: 'h-full grid flex-col gap-y-2 content-between justify-items-center', children: [_jsxs("div", { className: "text-sm flex flex-col gap-x-2", children: [_jsx("p", { children: t('store.exportInProgress') }), _jsx("p", { className: "pt-2 grid justify-items-center", children: t('store.pleaseWait') })] }), _jsx(Spinner, { size: 'lg' })] }) }));
}
//# sourceMappingURL=ExportPropertiesModal.js.map